import { render, staticRenderFns } from "./EarlypayIntro.vue?vue&type=template&id=52fe4d1c&scoped=true&"
import script from "./EarlypayIntro.vue?vue&type=script&lang=js&"
export * from "./EarlypayIntro.vue?vue&type=script&lang=js&"
import style0 from "./EarlypayIntro.vue?vue&type=style&index=0&id=52fe4d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe4d1c",
  null
  
)

export default component.exports